(function() {
    'use strict';

    angular.module('allegro').controller('AccountThreadsController', AccountThreadsController);

    AccountThreadsController.$inject = [
        '$scope',
        '$state',
        'lodashService',
        'notificationSrvc',
        'filterQuerySrvc',
        'searchFilterSrvc',
        'datatableDefaultPageSizeValueConst',
        'checkSearchSrvc',
        'allegroAccountDataSrvc',
        'allegroThreadPermissionsConst'
    ];

    function AccountThreadsController(
        $scope,
        $state,
        lodashService,
        notificationSrvc,
        filterQuerySrvc,
        searchFilterSrvc,
        datatableDefaultPageSizeValueConst,
        checkSearchSrvc,
        allegroAccountDataSrvc,
        allegroThreadPermissionsConst
    ) {
        var self = this;

        self.loading = true;

        self.isReadOptions = [
            { value: true, title: 'Tak' },
            { value: false, title: 'Nie' }
        ];

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.modelRows = [];
        self.modelCols = [
            {
                title: 'Klient',
                value: 'client.user.full_name',
                type: 'text',
                orderValue: 'client__user__first_name',
                searchable: true,
                orderable: true
            },
            {
                title: 'E-mail',
                value: 'client.user.email',
                type: 'link',
                linkTo: 'layout.client.details',
                linkParamProp: 'client_pk',
                orderValue: 'client__user__email',
                searchable: true,
                orderable: true
            },
            {
                title: 'Data ostatniej wiadomości',
                value: 'last_message_date_time',
                orderValue: 'last_message_date_time',
                type: 'text',
                searchable: true,
                orderable: true
            }
        ];

        self.exposingData = {
            color: {false: '#f8ac59'},
            conditionProp: 'read',
            conditionValue: false
        };

        self.modelPermissions = allegroThreadPermissionsConst;
        self.searchQuery = {
            'client.user.email': null,
            'client.user.full_name': null,
            last_message_date_time: null,
            ordering: null
        };
        self.filterData = {
            read: null
        }

        self.activate = activate;
        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;
        self.changeFilter = changeFilter;
        self.onEdit = onEdit;

        $scope.$watch('$parent.account', function(account) {
            if (account) {
                self.account = account;
                self.activate();
            }
        });

        function activate() {
            self.filterData = filterQuerySrvc.initializeFilterData(self.filterData);
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getThreads();
        }

        function getThreads(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    pk: $state.params.pk,

                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,

                    read: self.filterData.read,
                    client_email: self.searchQuery['client.user.email'],
                    client_name: self.searchQuery['client.user.full_name'],
                    last_message_date_time: searchFilterSrvc.getDatetimeValue(self.searchQuery.last_message_date_time),
                    ordering: self.searchQuery.ordering,
                };
            }

            return allegroAccountDataSrvc.getThreads(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.modelRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getThreads);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getThreads();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getThreads();
        }

        function changeFilter() {
            filterQuerySrvc.updateFilterData(self.filterData);
            filterQuerySrvc.setLocationParams();
            return getThreads();
        }

        function onEdit(row) {
            $state.go('layout.allegro-threads.details', { pk: row.pk });
        }
    }
})();
